import React, { useState, useRef, useEffect } from "react";
import ExportProgress from "./ExportProgress";
import PostConsultSummary from "./PostConsultSummary";
import { getPostConsultSummaryNodes } from "./PostConsultSummaryUtils";
import { Link } from "react-router-dom";
import { Row, Card, Col, Button, Modal, Container } from "react-bootstrap";
import { useAuth } from "../../../../context/AuthContext";
import { db } from "../../../../firebase";
import {
  setDoc,
  getDoc,
  updateDoc,
  doc,
  collection,
  getDocs,
  collectionGroup,
  where,
  query,
  orderBy,
} from "firebase/firestore";
import {
  setEvent,
  eventTmp,
  paymentPrivilages,
  orderList,
  colorList,
  statusList,
  typeList,
  PatientLinkInfo,
  PatientDropDownForm,
  PatientCheckboxForm,
  PatientCheckboxFormState,
  PatientTextInfo,
} from "../../Booking/BookingUtils";
import {
  FINISHED_REPORT_CHECK_NOT_PASSED_FILTER,
  FINISHED_REPORT_CHECK_PASSED_FILTER,
  SLEEP_STUDY_PATIENT_CONTACT_EXPORT_HEADERS,
  SLEEP_STUDY_REPORT_EXPORT_HEADERS,
  SLEEP_STUDY_REPORT_EXPORT_TITLE,
  getFinishedSleepStudyExcludedStatuses,
  getSleepStudyExportPhone,
  getSleepStudyPatientContactExportCells,
  getSleepStudyReportExportCheck,
  getSleepStudyReportExportCells,
  isFinishedSleepStudyExportFilter,
  shouldIncludeSleepStudyExportBooking,
} from "./SleepStudySummaryUtils";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

import * as XLSX from "xlsx";

import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../../components/toast/SetToast";
import Toast from "../../../components/toast/SetToast";
import { forEach } from "jszip";
import { set } from "date-fns";
import swal from "sweetalert";
import {
  filterCustomersForStaffNode,
  filterRecordsByStaffCustomerAccess,
  hasExplicitStaffCustomerAccess,
  isStaffCustomerScopedUser,
} from "../../../../utils/staffCustomerAccess";
import {
  BOOKING_SALE_FILTER_ALL,
  BOOKING_SALE_FILTER_UNASSIGNED,
  filterBookingsBySaleSelection,
} from "../../Booking/BookingSaleAccess";

const LockedStaffCustomerField = ({ customerIds }) => {
  const options = (customerIds || []).map((customerId) => ({
    value: customerId,
    label: customerId,
  }));

  return (
    <div className="form-group row">
      <label className="col-lg-3 col-form-label" htmlFor="export-customers">
        Customer
      </label>
      <div className="col-lg-5">
        <Select
          inputId="export-customers"
          aria-label="Customers assigned to this staff account"
          isMulti
          isDisabled
          options={options}
          value={options}
          placeholder="No customers assigned"
          styles={{
            multiValue: (base) => ({
              ...base,
              backgroundColor: "#e8f5ee",
            }),
            multiValueLabel: (base) => ({
              ...base,
              color: "#176b43",
            }),
          }}
        />
        <small className="text-muted d-block mt-1">
          Customer access is selected automatically from this staff account.
        </small>
      </div>
    </div>
  );
};

const SleepStudySummary = () => {
  const { currentUser } = useAuth();

  const [technicianList, setTechnicianList] = useState([]);
  const [techrecordList, setTechRecordList] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [doctorTHList, setDoctorTHList] = useState([]);
  const [saleList, setSaleList] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const [nodeList, setNodeList] = useState([]);
  const [nodeIdDocs, setNodeIdDocs] = useState([]);
  const [postConsultNodes, setPostConsultNodes] = useState([]);
  const [customerList, setCustomerList] = useState([]);
  const [customerAllList, setCustomerAllList] = useState([]);
  const [lockStaffCustomerFilter, setLockStaffCustomerFilter] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState("checked");
  const [isFinished, setIsFinished] = useState("");
  const [fetchingText, setFetchingText] = useState("");
  const [fetchingPatientText, SetFetchingPatientText] = useState("");
  const [listBookingError, setListBookingError] = useState([]);
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(null);
  const [exportError, setExportError] = useState("");
  const exportInProgress = useRef(false);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  var paymentPrivilagesData = paymentPrivilages;
  paymentPrivilagesData[0] = "All";

  const nodeRef = useRef();
  const customerRef = useRef();
  const healthInsuranceRef = useRef();
  const docRef = useRef();
  const saleRef = useRef();
  const techRef = useRef();
  const techRecordRef = useRef();
  const staffAccessContextRef = useRef({ adminData: null, nodes: [] });
  // const filterAllRef = useRef(
  //   "All cases except Sleep Test Scheduled , Cancel and Failure"
  // );
  const [selectedFilter, setSelectedFilter] = useState("Only finished cases");
  const [filterByStatus, setFilterByStatus] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");

  const selectCaseFilter = (filter) => {
    setSelectedFilter(filter);
    setFilterByStatus(false);
    setSelectedStatus("");
  };

  const buildQuery = (
    bookingsCollectionGroupRef,
    start,
    end,
    node,
    customer,
    insurance,
    techRecord,
    techScore,
    doctor,
    isFinishedCase,
  ) => {
    console.log("node: ", node);
    console.log("fetching...");

    var allStatusList = statusList;
    var exceptStatus = ["Cancel", "Failure"];
    var acceptStatus = allStatusList.filter(
      (status) => !exceptStatus.includes(status),
    );

    if (isFinishedSleepStudyExportFilter(isFinishedCase)) {
      exceptStatus = getFinishedSleepStudyExcludedStatuses(allStatusList);
      acceptStatus = allStatusList.filter(
        (status) => !exceptStatus.includes(status),
      );
    }

    var exceptStatusTech = ["Cancel", "Failure"];
    var acceptStatusTech = allStatusList.filter(
      (status) => !exceptStatusTech.includes(status),
    );

    var exceptStatusDoctor = [
      "Technician Scored",
      "Transferred To Center",
      "Assigned",
      "Sleep Test Scheduled",
      "Assigned to Doctor",

      "Cancel",
      "Failure",
    ];
    var acceptStatusDoctor = allStatusList.filter(
      (status) => !exceptStatusDoctor.includes(status),
    );

    if (isFinishedCase == "All cases") {
      exceptStatus = ["Cancel"];
      acceptStatus = allStatusList.filter(
        (status) => !exceptStatus.includes(status),
      );
    } else if (isFinishedCase == "All cases except Cancle and Failure") {
      exceptStatus = ["Cancel", "Failure"];
      acceptStatus = allStatusList.filter(
        (status) => !exceptStatus.includes(status),
      );
    } else if (
      isFinishedCase ==
      "All cases except Sleep Test Scheduled , Cancel and Failure"
    ) {
      exceptStatus = ["Sleep Test Scheduled", "Cancel", "Failure"];
      acceptStatus = allStatusList.filter(
        (status) => !exceptStatus.includes(status),
      );
    } else if (isFinishedCase == "Only Ship [CPAP Purchase]") {
      exceptStatus = [
        "Sleep Test Scheduled",
        "Transferred To Center",
        "Assigned",
        "Technician Scored",
        "Assigned to Doctor",
        "Doctor Scored",
        "Post-Consult",
        "Sale Follow Up",
        "Sale Follow Up [MC]",
        "Sale Follow Up [STM]",
        "Ready for CPAP Purchase",
        "Ship",
        // "Ship [CPAP Purchase]",
        "Ship [CPAP Trial]",
        "Ship [CPAP Rental]",
        "Ship [No CPAP]",
        "Cancel",
        "Failure",
      ];
      acceptStatus = allStatusList.filter(
        (status) => !exceptStatus.includes(status),
      );
    } else if (isFinishedCase == "Cancel and Failure cases only") {
      exceptStatus = [
        "Sleep Test Scheduled",
        "Transferred To Center",
        "Assigned",
        "Technician Scored",
        "Assigned to Doctor",
        "Doctor Scored",
        "Post-Consult",
        "Sale Follow Up",
        "Sale Follow Up [MC]",
        "Sale Follow Up [STM]",
        "Ready for CPAP Purchase",
        "Ship",
        "Ship [CPAP Purchase]",
        "Ship [CPAP Trial]",
        "Ship [CPAP Rental]",
        "Ship [No CPAP]",
        // "Cancel",
        // "Failure",
      ];
      acceptStatus = allStatusList.filter(
        (status) => !exceptStatus.includes(status),
      );
    } else if (isFinishedCase == "All cases with CPAP sold") {
      exceptStatus = ["Cancel"];
      acceptStatus = allStatusList.filter(
        (status) => !exceptStatus.includes(status),
      );
    }

    // console.log("isFinishedCase: ", isFinishedCase);

    let queryConstraints = [];

    queryConstraints.push(orderBy("extendedProps.latestSleepStudyDate"));

    const formatDate = (dateStr) => {
      const date = new Date(dateStr);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };

    const startDate = formatDate(start); // "2024-06-08"
    const endDate = formatDate(end); // "2024-08-05"

    queryConstraints.push(
      where("extendedProps.latestSleepStudyDate", ">=", startDate),
    );
    queryConstraints.push(
      where("extendedProps.latestSleepStudyDate", "<=", endDate),
    );

    if (node !== "All") {
      queryConstraints.push(where("extendedProps.node", "==", node));
    }
    // else if (node == "All" && currentUser.roles[0] == "admin") {
    //   queryConstraints.push(where("extendedProps.node", "in", nodeList));
    // }

    if (customer !== "All") {
      queryConstraints.push(where("extendedProps.customer", "==", customer));
    }

    if (insurance !== "All") {
      queryConstraints.push(
        where("extendedProps.healthInsurance", "==", insurance),
      );
    }

    if (techRecord !== "All") {
      queryConstraints.push(
        where("extendedProps.techrecord", "==", techRecord),
      );
    }

    if (techScore !== "All") {
      queryConstraints.push(where("extendedProps.technician", "==", techScore));
    }

    if (doctor !== "All") {
      queryConstraints.push(where("extendedProps.doctor", "==", doctor));
    }
    //////////////////////////////////////////////////////////////////////

    if (filterByStatus && selectedStatus) {
      queryConstraints.push(
        where("extendedProps.status", "==", selectedStatus),
      );
    } else if (isFinishedSleepStudyExportFilter(isFinishedCase)) {
      queryConstraints.push(
        where("extendedProps.status", "not-in", exceptStatus),
      );
    } else if (techRecord !== "All" || techScore !== "All") {
      queryConstraints.push(
        where("extendedProps.status", "not-in", exceptStatusTech),
      );
    } else if (doctor !== "All") {
      queryConstraints.push(
        where("extendedProps.status", "not-in", exceptStatusDoctor),
      );
    } else {
      if (exceptStatus.length >= 10) {
        queryConstraints.push(
          where("extendedProps.status", "in", acceptStatus),
        );
      } else {
        queryConstraints.push(
          where("extendedProps.status", "not-in", exceptStatus),
        );
      }
    }

    return query(bookingsCollectionGroupRef, ...queryConstraints);
  };

  const reduceDataByOrder = (dataArray) =>
    dataArray.reduce((acc, item) => {
      const order = item.extendedProps.order;

      if (!acc[order]) {
        acc[order] = item;
      }

      return acc;
    }, {});

  const getUniqueOrdersArray = (dataArray) =>
    Object.values(reduceDataByOrder(dataArray));

  const loadExportReportsByHn = async (bookings = []) => {
    const hns = Array.from(
      new Set(
        (Array.isArray(bookings) ? bookings : [])
          .map((booking) => {
            const bookingProps = (booking && booking.extendedProps) || {};
            return String(bookingProps.hn || "").trim();
          })
          .filter(Boolean),
      ),
    );
    const reportsByHn = hns.reduce((reportMap, hn) => {
      reportMap[hn] = [];
      return reportMap;
    }, {});

    setExportProgress({ percent: 75, message: `Checking report files: 0 / ${hns.length}` });
    for (let index = 0; index < hns.length; index += 10) {
      const hnChunk = hns.slice(index, index + 10);
      SetFetchingPatientText(
        `Checking report files ${Math.min(index + hnChunk.length, hns.length)}/${hns.length}...`,
      );
      const reportSnapshots = await Promise.all(
        hnChunk.map((hn) => getDocs(collection(db, "patients", hn, "report"))),
      );

      reportSnapshots.forEach((reportSnapshot, snapshotIndex) => {
        const hn = hnChunk[snapshotIndex];
        reportsByHn[hn] = reportSnapshot.docs.reduce((reports, reportDoc) => {
          const reportData = reportDoc.data();
          const reportHn = String(reportData.hn || hn).trim();

          if (reportHn === hn) {
            reports.push({ id: reportDoc.id, ...reportData, hn: reportHn });
          }

          return reports;
        }, []);
      });
      const completed = Math.min(index + hnChunk.length, hns.length);
      setExportProgress({
        percent: 75 + Math.floor((completed / hns.length) * 15),
        message: `Checking report files: ${completed} / ${hns.length}`,
      });
    }

    return reportsByHn;
  };

  const getCustomerVisibleBookings = (bookings = []) => {
    const accessContext = staffAccessContextRef.current;
    return filterRecordsByStaffCustomerAccess({
      records: bookings,
      currentUser,
      adminData: accessContext.adminData,
      nodes: accessContext.nodes,
      getNodeValue: (booking) =>
        booking.extendedProps && booking.extendedProps.node,
      getCustomerValue: (booking) =>
        booking.extendedProps && booking.extendedProps.customer,
    });
  };

  const getVisibleExportBookings = (
    bookings = [],
    selectedSale = BOOKING_SALE_FILTER_ALL,
  ) =>
    filterBookingsBySaleSelection({
      records: getCustomerVisibleBookings(bookings),
      selectedSale,
    });

  const prepareExportBookings = async (
    bookings = [],
    selectedSale = BOOKING_SALE_FILTER_ALL,
  ) => {
    const visibleBookings = getVisibleExportBookings(bookings, selectedSale);
    const uniqueBookings = getUniqueOrdersArray(visibleBookings);
    const reportsByHn = await loadExportReportsByHn(uniqueBookings);

    return uniqueBookings
      .map((booking) => {
        const bookingProps = (booking && booking.extendedProps) || {};
        const hn = String(bookingProps.hn || "").trim();

        return {
          ...booking,
          reportCheck: getSleepStudyReportExportCheck(
            booking,
            reportsByHn[hn] || [],
          ),
        };
      })
      .filter((booking) =>
        shouldIncludeSleepStudyExportBooking(booking, selectedFilter),
      );
  };

  const onExport = async () => {
    if (exportInProgress.current) return;
    if (filterByStatus && !selectedStatus) {
      notifyWarning("Please select a status before exporting.");
      return;
    }
    exportInProgress.current = true;
    setIsExporting(true);
    setExportError("");
    setExportProgress({ percent: 0, message: "Loading sleep study records..." });
    try {
      await exportSummary();
      setExportProgress({ percent: 100, message: "Export ready. Download started." });
    } catch (error) {
      setExportProgress(null);
      setExportError(`Unable to export Sleep Study Summary: ${error.message || "Please try again."}`);
    } finally {
      exportInProgress.current = false;
      setIsExporting(false);
      setFetchingText("");
      SetFetchingPatientText("");
    }
  };

  const exportSummary = async () => {
    const node = nodeRef.current.value;
    // Restricted staff always export every customer granted for the selected
    // node. The shared access filter remains authoritative for exact pairs.
    const customer = lockStaffCustomerFilter
      ? "All"
      : customerRef.current.value;
    const insurance = healthInsuranceRef.current.value;
    const techRecord = techRecordRef.current.value;
    const techScore = techRef.current.value;
    const doctor = docRef.current.value;
    const sale = saleRef.current.value;

    const start = startDate;
    const end = endDate;

    // Split the booking stage across the known node queries, then advance
    // within each query as its patient records are processed.
    const matchingTechnician = techRecord === techScore && techRecord !== "All";
    const totalQueries = Math.max(1, matchingTechnician
      ? nodeList.filter((item) => item !== "All").length * 2
      : node === "All" ? nodeList.filter((item) => item !== "All").length : 1);
    let queryIndex = -1;
    const updateBookingProgress = (completed, total) => {
      const fraction = total ? 0.1 + (completed / total) * 0.9 : 0;
      setExportProgress({
        percent: 5 + Math.floor(((queryIndex + fraction) / totalQueries) * 70),
        message: total
          ? `Checking patient records: ${completed} / ${total} (query ${queryIndex + 1} / ${totalQueries})`
          : `Loading sleep study records: query ${queryIndex + 1} / ${totalQueries}`,
      });
    };
    const fetchExportBookings = async (bookingQuery) => {
      queryIndex += 1;
      updateBookingProgress(0, 0);
      return getDocs(bookingQuery);
    };

    // if (node == "All") {
    // } else {
    // Usage of the buildQuery function
    let bookingsCollectionGroupRef = collectionGroup(db, "bookings");
    let queryHandler;
    let tempBooking = [];
    let combinedResults = [];
    let tempErrorBooking = [];
    // filter by tech or doctor
    if (techRecord === techScore && techRecord !== "All") {
      for (const nodeItem of nodeList) {
        setFetchingText(`Fetching data from ${nodeItem}...`);
        SetFetchingPatientText("");
        if (nodeItem === "All") continue;
        // Step 1: Query based on techRecord (techScore = "All")
        if (techRecord !== "All") {
          const queryHandler1 = buildQuery(
            bookingsCollectionGroupRef,
            start,
            end,
            nodeItem,
            customer,
            insurance,
            techRecord,
            "All", // techScore ignored
            doctor,
            selectedFilter,
          );

          const docSnap1 = await fetchExportBookings(queryHandler1);
          for (const [index, booking] of docSnap1.docs.entries()) {
            updateBookingProgress(index, docSnap1.docs.length);
            var bookingData = booking.data();
            if (getVisibleExportBookings([bookingData], sale).length === 0) {
              continue;
            }
            if (bookingData.extendedProps.hn === "") {
              console.log("not found hn !");
              console.log(bookingData); // just log it
              console.log("");
              tempErrorBooking.push(bookingData);
              continue; // skip the rest of the code
            }

            SetFetchingPatientText(
              `Fetching patient data from ${bookingData.extendedProps.hn}...`,
            );
            const hn = bookingData.extendedProps.hn;
            const docPatientRef = doc(db, "patients", hn);
            const docPatientSnap = await getDoc(docPatientRef);
            if (docPatientSnap.exists()) {
              const patientData = docPatientSnap.data();
              bookingData.extendedProps.dob = patientData.dateOfBirth;
              bookingData.extendedProps.phone = getSleepStudyExportPhone(
                patientData,
                bookingData,
              );
              bookingData.extendedProps.nationalId = patientData.nationalId;
              bookingData.extendedProps.updateHealthInsurance =
                patientData.updateHealthInsurance;
              bookingData.extendedProps.updateHealthInsuranceNote =
                patientData.updateHealthInsuranceNote;
            } else {
              bookingData.extendedProps.dob = "";
              bookingData.extendedProps.phone = getSleepStudyExportPhone(
                {},
                bookingData,
              );
              bookingData.extendedProps.nationalId = "";
              bookingData.extendedProps.updateHealthInsurance = "";
              bookingData.extendedProps.updateHealthInsuranceNote = "";
            }
            const dateStart = new Date(bookingData.start.toDate());
            dateStart.setHours(dateStart.getHours() + 7);
            bookingData.start = dateStart.toISOString().slice(0, 10);
            combinedResults.push({ ...bookingData });
          }
        }

        // Step 2: Query based on techScore (techRecord = "All")
        if (techScore !== "All") {
          const queryHandler2 = buildQuery(
            bookingsCollectionGroupRef,
            start,
            end,
            nodeItem,
            customer,
            insurance,
            "All", // techRecord ignored
            techScore,
            doctor,
            selectedFilter,
          );

          const docSnap2 = await fetchExportBookings(queryHandler2);
          for (const [index, booking] of docSnap2.docs.entries()) {
            updateBookingProgress(index, docSnap2.docs.length);
            const bookingData = booking.data();
            if (getVisibleExportBookings([bookingData], sale).length === 0) {
              continue;
            }

            if (bookingData.extendedProps.hn === "") {
              console.log("not found hn !");
              console.log(bookingData); // just log it
              console.log("");
              tempErrorBooking.push(bookingData);
              continue; // skip the rest of the code
            }

            SetFetchingPatientText(
              `Fetching patient data from ${bookingData.extendedProps.hn}...`,
            );
            const hn = bookingData.extendedProps.hn;
            const docPatientRef = doc(db, "patients", hn);
            const docPatientSnap = await getDoc(docPatientRef);
            if (docPatientSnap.exists()) {
              const patientData = docPatientSnap.data();
              bookingData.extendedProps.dob = patientData.dateOfBirth;
              bookingData.extendedProps.phone = getSleepStudyExportPhone(
                patientData,
                bookingData,
              );
              bookingData.extendedProps.nationalId = patientData.nationalId;
              bookingData.extendedProps.updateHealthInsurance =
                patientData.updateHealthInsurance;
              bookingData.extendedProps.updateHealthInsuranceNote =
                patientData.updateHealthInsuranceNote;
            } else {
              bookingData.extendedProps.dob = "";
              bookingData.extendedProps.phone = getSleepStudyExportPhone(
                {},
                bookingData,
              );
              bookingData.extendedProps.nationalId = "";
              bookingData.extendedProps.updateHealthInsurance = "";
              bookingData.extendedProps.updateHealthInsuranceNote = "";
            }

            const dateStart = new Date(bookingData.start.toDate());
            dateStart.setHours(dateStart.getHours() + 7);
            bookingData.start = dateStart.toISOString().slice(0, 10);
            combinedResults.push({ ...bookingData });
          }
        }
      }

      // console.log(combinedResults);

      const uniqueResults = await prepareExportBookings(combinedResults, sale);
      if (selectedFilter == "All cases with CPAP sold") {
        console.log("before filter uniqueResults: ", uniqueResults);
      }

      setFetchingText(``);
      SetFetchingPatientText(``);

      setBookingList(uniqueResults);

      await createXLSXOtherNode(
        uniqueResults,
        node,
        customer,
        insurance,
        techRecord,
        techScore,
        doctor,
        start,
        end,
      );
    }
    // filter by node or all node
    else {
      if (node === "All") {
        for (const nodeItem of nodeList) {
          setFetchingText(`Fetching data from ${nodeItem}...`);
          SetFetchingPatientText(``);
          if (nodeItem === "All") continue;
          const queryHandler = buildQuery(
            bookingsCollectionGroupRef,
            start,
            end,
            nodeItem, // use each node from nodeList
            customer,
            insurance,
            techRecord,
            techScore,
            doctor,
            selectedFilter,
          );

          const docSnap = await fetchExportBookings(queryHandler);
          if (docSnap.empty) {
            console.log(`No documents found for node: ${nodeItem}`);
          } else {
            for (const [index, booking] of docSnap.docs.entries()) {
              updateBookingProgress(index, docSnap.docs.length);
              const bookingData = booking.data();
              if (getVisibleExportBookings([bookingData], sale).length === 0) {
                continue;
              }

              if (bookingData.extendedProps.hn === "") {
                console.log("not found hn !");
                console.log(bookingData); // just log it
                console.log("");
                tempErrorBooking.push(bookingData);
                continue; // skip the rest of the code
              }

              SetFetchingPatientText(
                `Fetching patient data from ${bookingData.extendedProps.hn}...`,
              );
              const hn = bookingData.extendedProps.hn;
              const docPatientRef = doc(db, "patients", hn);
              const docPatientSnap = await getDoc(docPatientRef);
              if (docPatientSnap.exists()) {
                const patientData = docPatientSnap.data();
                bookingData.extendedProps.dob = patientData.dateOfBirth;
                bookingData.extendedProps.phone = getSleepStudyExportPhone(
                  patientData,
                  bookingData,
                );
                bookingData.extendedProps.nationalId = patientData.nationalId;
                bookingData.extendedProps.updateHealthInsurance =
                  patientData.updateHealthInsurance;
                bookingData.extendedProps.updateHealthInsuranceNote =
                  patientData.updateHealthInsuranceNote;
              } else {
                bookingData.extendedProps.dob = "";
                bookingData.extendedProps.phone = getSleepStudyExportPhone(
                  {},
                  bookingData,
                );
                bookingData.extendedProps.nationalId = "";
                bookingData.extendedProps.updateHealthInsurance = "";
                bookingData.extendedProps.updateHealthInsuranceNote = "";
              }
              const dateStart = new Date(bookingData.start.toDate());
              dateStart.setHours(dateStart.getHours() + 7);
              bookingData.start = dateStart.toISOString().slice(0, 10);
              tempBooking.push({ ...bookingData });
            }
          }
        }
      } else {
        const queryHandler = buildQuery(
          bookingsCollectionGroupRef,
          start,
          end,
          node, // use each node from nodeList
          customer,
          insurance,
          techRecord,
          techScore,
          doctor,
          selectedFilter,
        );

        const docSnap = await fetchExportBookings(queryHandler);
        if (docSnap.empty) {
          console.log(`No documents found for node: ${node}`);
        } else {
          for (const [index, booking] of docSnap.docs.entries()) {
            updateBookingProgress(index, docSnap.docs.length);
            const bookingData = booking.data();
            if (getVisibleExportBookings([bookingData], sale).length === 0) {
              continue;
            }

            if (bookingData.extendedProps.hn === "") {
              console.log("not found hn !");
              console.log(bookingData); // just log it
              console.log("");
              tempErrorBooking.push(bookingData);
              continue; // skip the rest of the code
            }

            SetFetchingPatientText(
              `Fetching patient data from ${bookingData.extendedProps.hn}...`,
            );
            const hn = bookingData.extendedProps.hn;
            const docPatientRef = doc(db, "patients", hn);
            const docPatientSnap = await getDoc(docPatientRef);
            if (docPatientSnap.exists()) {
              const patientData = docPatientSnap.data();
              bookingData.extendedProps.dob = patientData.dateOfBirth;
              bookingData.extendedProps.phone = getSleepStudyExportPhone(
                patientData,
                bookingData,
              );
              bookingData.extendedProps.nationalId = patientData.nationalId;
              bookingData.extendedProps.updateHealthInsurance =
                patientData.updateHealthInsurance;
              bookingData.extendedProps.updateHealthInsuranceNote =
                patientData.updateHealthInsuranceNote;
            } else {
              bookingData.extendedProps.dob = "";
              bookingData.extendedProps.phone = getSleepStudyExportPhone(
                {},
                bookingData,
              );
              bookingData.extendedProps.nationalId = "";
              bookingData.extendedProps.updateHealthInsurance = "";
              bookingData.extendedProps.updateHealthInsuranceNote = "";
            }
            const dateStart = new Date(bookingData.start.toDate());
            dateStart.setHours(dateStart.getHours() + 7);
            bookingData.start = dateStart.toISOString().slice(0, 10);
            tempBooking.push({ ...bookingData });
          }
        }
      }
      const uniqueResults = await prepareExportBookings(tempBooking, sale);
      if (selectedFilter == "All cases with CPAP sold") {
        console.log("before filter uniqueResults: ", uniqueResults);
      }

      setFetchingText(``);
      SetFetchingPatientText(``);

      setBookingList(uniqueResults);
      await createXLSXOtherNode(
        uniqueResults,
        node,
        customer,
        insurance,
        techRecord,
        techScore,
        doctor,
        start,
        end,
      );
    }

    if (tempErrorBooking.length > 0) {
      const errorMessages = tempErrorBooking
        .map(function (b, i) {
          return (
            i +
            1 +
            ". " +
            (b.title || "No Title") +
            " <===> " +
            ((b.extendedProps && b.extendedProps.latestSleepStudyDate) ||
              "No Date")
          );
        })
        .join("\n");

      swal({
        title: "Warning",
        text: `Some patients have no HN data:\n\n${errorMessages}`,
        icon: "warning",
        button: "OK",
      });
    }

    tempErrorBooking = [];
    // }
  };

  const checkItems = (array) => {
    let hasHomeFull = false;
    let hasSplitNight = false;
    let hasPremium = false;
    let hasCPAPt = false;
    let hasOvernightPulse = false;

    for (const item of array) {
      if (item.item.includes("Split Night")) {
        hasSplitNight = true;
      }
      if (item.item.includes("Premium")) {
        hasPremium = true;
      }
      if (item.item.includes("Home")) {
        hasHomeFull = true;
      }
      if (item.item.includes("CPAP Titration")) {
        hasCPAPt = true;
      }
      if (item.item.includes("Overnight")) {
        hasOvernightPulse = true;
      }
    }

    return [
      hasSplitNight,
      hasPremium,
      hasHomeFull,
      hasCPAPt,
      hasOvernightPulse,
    ];
  };

  const formatDateRangeInThai = (startDateStr, endDateStr) => {
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);

    const options = { year: "numeric", month: "long", day: "numeric" };
    const thaiFormatter = new Intl.DateTimeFormat("th-TH", options);

    const startDay = startDate.getDate();
    const startMonth = startDate.toLocaleString("th-TH", { month: "long" });
    const startYear = startDate.getFullYear();

    const endDay = endDate.getDate();
    const endMonth = endDate.toLocaleString("th-TH", { month: "long" });
    const endYear = endDate.getFullYear();

    if (startYear === endYear) {
      if (startMonth === endMonth) {
        return `${startDay} - ${endDay} ${startMonth} ${startYear}`;
      }
      return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${startYear}`;
    }

    const formattedStartDate = thaiFormatter.format(startDate);
    const formattedEndDate = thaiFormatter.format(endDate);

    return `${formattedStartDate} - ${formattedEndDate}`;
  };

  const createXLSXOtherNode = async (
    bookingData,
    node,
    customer,
    insurance,
    techRecord,
    techScore,
    doctor,
    start,
    end,
  ) => {
    setExportProgress({ percent: 95, message: "Preparing Excel file..." });
    await new Promise((resolve) => setTimeout(resolve, 0));
    const rangeDate = formatDateRangeInThai(start, end);

    var fullNightStandard = [];
    var splitNightStandard = [];

    var fullNightPremium = [];
    var splitNightPremium = [];

    var overnightPulse = [];

    var xlsxName = "";
    var sheetName = "";

    var textHeader = "";
    if (node != "All") {
      textHeader = textHeader + node;
      xlsxName = rangeDate + " " + node;
      sheetName = node;

      if (customer != "All") {
        textHeader = textHeader + " - " + customer;
        xlsxName = xlsxName + " - " + customer;
        sheetName = customer;
      }

      if (insurance != "All") {
        textHeader = textHeader + " เคส " + insurance;
        xlsxName = xlsxName + " เคส " + insurance;
        sheetName = sheetName + " เคส " + insurance;
      } else {
        textHeader = textHeader + " เคสทั้งหมด";
        xlsxName = xlsxName + " เคสทั้งหมด";
        sheetName = sheetName + " เคสทั้งหมด";
      }
    } else {
      if (doctor != "") {
        textHeader = textHeader + " แพทย์ผู้อ่านผล " + doctor;
        xlsxName = rangeDate + " แพทย์ผู้อ่านผล " + doctor;
        sheetName = doctor;
      }
      if (techRecord != "") {
        textHeader = textHeader + " Recording Tech " + techRecord;
        xlsxName = rangeDate + " Recording Tech " + techRecord;
        sheetName = doctor;
      }
      if (techScore != "") {
        textHeader = textHeader + " Scoring Tech " + techScore;
        xlsxName = rangeDate + " Scoring Tech " + techScore;
        sheetName = doctor;
      }
    }
    const fileName = `${rangeDate} ${textHeader}`;
    if (node == "Ladprao Hospital") {
      const head = Array(30).fill("");
      head[0] = fileName;
      const headers = [
        "ลำดับ",
        "วันที่ตรวจการนอนหลับ",
        "Status ล่าสุด",
        "Sleep Study No.",
        "โรงพยาบาลผู้ส่งตรวจ",
        "อัพเดตสิทธิการรักษา",
        "รายละเอียด",
        "ชื่อ - นามสกุล",
        "รหัสโรงพยาบาล",
        ...SLEEP_STUDY_PATIENT_CONTACT_EXPORT_HEADERS,
        "ชนิดการตรวจการนอนหลับ",
        "",
        "แพ็คการตรวจการนอนหลับ",
        "",
        "",
        "",
        "เงินสด",
        SLEEP_STUDY_REPORT_EXPORT_TITLE,
        "",
        "",
        "รายละเอียดแพ็คเกจ",
        "ค่าตอบแทนตามสัญญา",
        "AHI (ครั้ง/ชั่วโมง)",
        "",
        "",
        "แพทย์อ่านผล",
        "Recording Tech",
        "Scoring Tech",
        "หมายเหตุ",
      ];
      const subHeaders = [
        ...Array(11).fill(""),
        "FN",
        "SN",
        "FN - St",
        "SN - St",
        "FN - Pr",
        "SN - Pr",
        "",
        ...SLEEP_STUDY_REPORT_EXPORT_HEADERS,
        "",
        "",
        "AHI < 15",
        "15 <= AHI < 30",
        "AHI >= 30",
        "",
        "",
        "",
        "",
      ];

      const data = [head, headers, subHeaders];
      bookingData.forEach((booking, index) => {
        const row = [];

        row.push(index + 1);
        row.push(booking.extendedProps.latestSleepStudyDate);
        row.push(booking.extendedProps.status);
        row.push(booking.title);
        row.push(booking.extendedProps.customer);
        row.push(booking.extendedProps.updateHealthInsurance);
        row.push(booking.extendedProps.updateHealthInsuranceNote);
        row.push(
          `${booking.extendedProps.firstname} ${booking.extendedProps.lastname}`,
        );
        row.push(booking.extendedProps.hospitalNumber);
        row.push(...getSleepStudyPatientContactExportCells(booking));
        // row.push(booking.extendedProps.nationalId);

        const [hasSplitNight, hasPremium, hasHomeFull, hasCPAPt] = checkItems(
          booking.extendedProps.items,
        );

        if (hasSplitNight) {
          row.push("");
        } else {
          row.push("✅");
        }

        if (hasSplitNight) {
          row.push("✅");
        } else {
          row.push("");
        }

        if (!hasSplitNight && !hasPremium) {
          row.push("✅");
          fullNightStandard.push(booking);
        } else {
          row.push("");
        }

        if (hasSplitNight && !hasPremium) {
          row.push("✅");
          splitNightStandard.push(booking);
        } else {
          row.push("");
        }

        if (!hasSplitNight && hasPremium) {
          row.push("✅");
          fullNightPremium.push(booking);
        } else {
          row.push("");
        }

        if (hasSplitNight && hasPremium) {
          row.push("✅");
          splitNightPremium.push(booking);
        } else {
          row.push("");
        }
        //เช็คเงินสด
        if (
          ["ชำระเงินเอง", "เงินสด"].includes(
            String(booking.extendedProps.healthInsurance || "").trim(),
          )
        ) {
          row.push("✅");
        } else {
          row.push("");
        }
        row.push(...getSleepStudyReportExportCells(booking.reportCheck));
        const itemsText = [];
        booking.extendedProps.items.forEach((item) => {
          itemsText.push(`${item.item} (${item.unitcost})`);
        });

        row.push(itemsText.join("\n"));

        if (hasSplitNight) {
          row.push(7000);
        } else {
          row.push(4000);
        }

        if (booking.extendedProps.ahi && booking.extendedProps.ahi != "") {
          if (parseFloat(booking.extendedProps.ahi) < 15) {
            row.push(parseFloat(booking.extendedProps.ahi));
            row.push("");
            row.push("");
          } else if (
            parseFloat(booking.extendedProps.ahi) >= 15 &&
            parseFloat(booking.extendedProps.ahi) < 30
          ) {
            row.push("");
            row.push(parseFloat(booking.extendedProps.ahi));
            row.push("");
          } else if (parseFloat(booking.extendedProps.ahi) >= 30) {
            row.push("");
            row.push("");
            row.push(parseFloat(booking.extendedProps.ahi));
          }
        } else {
          row.push("");
          row.push("");
          row.push("");
        }
        row.push(GetFullNameDoctor(booking.extendedProps.doctor));
        row.push(booking.extendedProps.techrecord);
        row.push(booking.extendedProps.technician);
        row.push(booking.extendedProps.note);
        // console.log(row.length);

        data.push(row);
      });

      const allCases =
        fullNightStandard.length +
        splitNightStandard.length +
        fullNightPremium.length +
        splitNightPremium.length;
      const summaryRow = Array(30).fill("");
      summaryRow[12] = "รวม";
      summaryRow[13] = fullNightStandard.length;
      summaryRow[14] = splitNightStandard.length;
      summaryRow[15] = fullNightPremium.length;
      summaryRow[16] = splitNightPremium.length;
      summaryRow[17] = "รวมทั้งสิ้น";
      summaryRow[21] = `${allCases} เคส`;
      data.push(summaryRow);

      const ws = XLSX.utils.aoa_to_sheet(data);

      // Define the merge ranges
      const merge = [];

      merge.push(
        { s: { r: 0, c: 0 }, e: { r: 0, c: 29 } },

        { s: { r: 1, c: 0 }, e: { r: 2, c: 0 } },
        { s: { r: 1, c: 1 }, e: { r: 2, c: 1 } },
        { s: { r: 1, c: 2 }, e: { r: 2, c: 2 } },
        { s: { r: 1, c: 3 }, e: { r: 2, c: 3 } },
        { s: { r: 1, c: 4 }, e: { r: 2, c: 4 } },
        { s: { r: 1, c: 5 }, e: { r: 2, c: 5 } },
        { s: { r: 1, c: 6 }, e: { r: 2, c: 6 } },
        { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } },
        { s: { r: 1, c: 8 }, e: { r: 2, c: 8 } },
        { s: { r: 1, c: 9 }, e: { r: 2, c: 9 } },
        { s: { r: 1, c: 10 }, e: { r: 2, c: 10 } },

        { s: { r: 1, c: 11 }, e: { r: 1, c: 12 } },
        { s: { r: 2, c: 11 }, e: { r: 2, c: 11 } },
        { s: { r: 2, c: 12 }, e: { r: 2, c: 12 } },

        { s: { r: 1, c: 13 }, e: { r: 1, c: 16 } },
        { s: { r: 2, c: 13 }, e: { r: 2, c: 13 } },
        { s: { r: 2, c: 14 }, e: { r: 2, c: 14 } },
        { s: { r: 2, c: 15 }, e: { r: 2, c: 15 } },
        { s: { r: 2, c: 16 }, e: { r: 2, c: 16 } },

        { s: { r: 1, c: 17 }, e: { r: 2, c: 17 } },
        { s: { r: 1, c: 18 }, e: { r: 1, c: 20 } },
        { s: { r: 2, c: 18 }, e: { r: 2, c: 18 } },
        { s: { r: 2, c: 19 }, e: { r: 2, c: 19 } },
        { s: { r: 2, c: 20 }, e: { r: 2, c: 20 } },

        { s: { r: 1, c: 21 }, e: { r: 2, c: 21 } },
        { s: { r: 1, c: 22 }, e: { r: 2, c: 22 } },

        { s: { r: 1, c: 23 }, e: { r: 1, c: 25 } },
        { s: { r: 2, c: 23 }, e: { r: 2, c: 23 } },
        { s: { r: 2, c: 24 }, e: { r: 2, c: 24 } },
        { s: { r: 2, c: 25 }, e: { r: 2, c: 25 } },

        { s: { r: 1, c: 26 }, e: { r: 2, c: 26 } },
        { s: { r: 1, c: 27 }, e: { r: 2, c: 27 } },
        { s: { r: 1, c: 28 }, e: { r: 2, c: 28 } },
        { s: { r: 1, c: 29 }, e: { r: 2, c: 29 } },
      );
      ws["!merges"] = merge;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Summary Report");
      XLSX.writeFile(wb, `Summary ${xlsxName}.xlsx`);
    } else {
      const head = Array(34).fill("");
      head[0] = fileName;
      const headers = [
        "ลำดับ",
        "วันที่ตรวจการนอนหลับ",
        "Status ล่าสุด",
        "Sleep Study No.",
        "โรงพยาบาลผู้ส่งตรวจ",
        "อัพเดตสิทธิการรักษา",
        "รายละเอียด",
        "ชื่อ - นามสกุล",
        "รหัสโรงพยาบาล",
        ...SLEEP_STUDY_PATIENT_CONTACT_EXPORT_HEADERS,
        "เลขบัตรประชาชน",
        "ชนิดการตรวจการนอนหลับ",
        "",
        "",
        "",
        "",
        "แพ็คการตรวจการนอนหลับ",
        "",
        "",
        "",
        "",
        "เงินสด",
        SLEEP_STUDY_REPORT_EXPORT_TITLE,
        "",
        "",
        "รายละเอียดแพ็คเกจ",
        "AHI (ครั้ง/ชั่วโมง)",
        "",
        "",
        "แพทย์อ่านผล",
        "Recording Tech",
        "Scoring Tech",
        "หมายเหตุ",
      ];
      const subHeaders = [
        ...Array(12).fill(""),
        "FN",
        "SN",
        "HN",
        "CT",
        "OPO",
        "FN - St",
        "SN - St",
        "FN - Pr",
        "SN - Pr",
        "OPO",
        "",
        ...SLEEP_STUDY_REPORT_EXPORT_HEADERS,
        "",
        "AHI < 15",
        "15 <= AHI < 30",
        "AHI >= 30",
        "",
        "",
        "",
        "",
      ];

      const data = [head, headers, subHeaders];
      bookingData.forEach((booking, index) => {
        const row = [];

        row.push(index + 1);
        row.push(booking.extendedProps.latestSleepStudyDate);
        row.push(booking.extendedProps.status);
        row.push(booking.title);
        row.push(booking.extendedProps.customer);
        row.push(booking.extendedProps.updateHealthInsurance);
        row.push(booking.extendedProps.updateHealthInsuranceNote);
        row.push(
          `${booking.extendedProps.firstname} ${booking.extendedProps.lastname}`,
        );
        row.push(booking.extendedProps.hospitalNumber);
        row.push(...getSleepStudyPatientContactExportCells(booking));
        row.push(booking.extendedProps.nationalId);

        const [
          hasSplitNight,
          hasPremium,
          hasHomeFull,
          hasCPAPt,
          hasOvernightPulse,
        ] = checkItems(booking.extendedProps.items);
        // console.log("checkItems: ", checkItems(booking.extendedProps.items));
        //ชนิดตรวจ full night
        if (hasSplitNight || hasHomeFull || hasOvernightPulse) {
          row.push("");
        } else {
          row.push("✅");
        }
        //ชนิดตรวจ split night
        if (hasSplitNight && !hasOvernightPulse) {
          row.push("✅");
        } else {
          row.push("");
        }
        //ชนิดตรวจ = home
        if (hasHomeFull && !hasOvernightPulse) {
          row.push("✅");
        } else {
          row.push("");
        }
        //ชนิดตรวจ cpap titration
        if (hasCPAPt && !hasOvernightPulse) {
          row.push("✅");
        } else {
          row.push("");
        }
        if (hasOvernightPulse) {
          row.push("✅");
        } else {
          row.push("");
        }
        //แพ็คตรวจการนอนหลับ
        if (!hasSplitNight && !hasPremium && !hasOvernightPulse) {
          row.push("✅");
          fullNightStandard.push(booking);
        } else {
          row.push("");
        }

        if (hasSplitNight && !hasPremium && !hasOvernightPulse) {
          row.push("✅");
          splitNightStandard.push(booking);
        } else {
          row.push("");
        }

        if (!hasSplitNight && hasPremium && !hasOvernightPulse) {
          row.push("✅");
          fullNightPremium.push(booking);
        } else {
          row.push("");
        }

        if (hasSplitNight && hasPremium && !hasOvernightPulse) {
          row.push("✅");
          splitNightPremium.push(booking);
        } else {
          row.push("");
        }
        if (hasOvernightPulse) {
          row.push("✅");
          overnightPulse.push(booking);
        } else {
          row.push("");
        }
        //เช็คเงินสด
        if (
          ["ชำระเงินเอง", "เงินสด"].includes(
            String(booking.extendedProps.healthInsurance || "").trim(),
          )
        ) {
          row.push("✅");
        } else {
          row.push("");
        }
        row.push(...getSleepStudyReportExportCells(booking.reportCheck));
        //รายละเอียดแพ็คเกจ
        const itemsText = [];
        booking.extendedProps.items.forEach((item) => {
          itemsText.push(`${item.item} (${item.unitcost})`);
        });
        row.push(itemsText.join("\n"));

        if (booking.extendedProps.ahi && booking.extendedProps.ahi != "") {
          if (parseFloat(booking.extendedProps.ahi) < 15) {
            row.push(parseFloat(booking.extendedProps.ahi));
            row.push("");
            row.push("");
          } else if (
            parseFloat(booking.extendedProps.ahi) >= 15 &&
            parseFloat(booking.extendedProps.ahi) < 30
          ) {
            row.push("");
            row.push(parseFloat(booking.extendedProps.ahi));
            row.push("");
          } else if (parseFloat(booking.extendedProps.ahi) >= 30) {
            row.push("");
            row.push("");
            row.push(parseFloat(booking.extendedProps.ahi));
          }
        } else {
          row.push("");
          row.push("");
          row.push("");
        }

        row.push(GetFullNameDoctor(booking.extendedProps.doctor));
        row.push(booking.extendedProps.techrecord);
        row.push(booking.extendedProps.technician);
        row.push(booking.extendedProps.note);
        // console.log(row.length);

        data.push(row);
      });
      const allCases =
        fullNightStandard.length +
        splitNightStandard.length +
        fullNightPremium.length +
        splitNightPremium.length +
        overnightPulse.length;
      const summaryRow = Array(34).fill("");
      summaryRow[16] = "รวม";
      summaryRow[17] = fullNightStandard.length;
      summaryRow[18] = splitNightStandard.length;
      summaryRow[19] = fullNightPremium.length;
      summaryRow[20] = splitNightPremium.length;
      summaryRow[21] = overnightPulse.length;
      summaryRow[22] = "รวมทั้งสิ้น";
      summaryRow[26] = `${allCases} เคส`;
      data.push(summaryRow);

      const ws = XLSX.utils.aoa_to_sheet(data);

      // Define the merge ranges
      const merge = [];

      merge.push(
        { s: { r: 0, c: 0 }, e: { r: 0, c: 33 } },

        { s: { r: 1, c: 0 }, e: { r: 2, c: 0 } },
        { s: { r: 1, c: 1 }, e: { r: 2, c: 1 } },
        { s: { r: 1, c: 2 }, e: { r: 2, c: 2 } },
        { s: { r: 1, c: 3 }, e: { r: 2, c: 3 } },
        { s: { r: 1, c: 4 }, e: { r: 2, c: 4 } },
        { s: { r: 1, c: 5 }, e: { r: 2, c: 5 } },
        { s: { r: 1, c: 6 }, e: { r: 2, c: 6 } },
        { s: { r: 1, c: 7 }, e: { r: 2, c: 7 } },
        { s: { r: 1, c: 8 }, e: { r: 2, c: 8 } },
        { s: { r: 1, c: 9 }, e: { r: 2, c: 9 } },
        { s: { r: 1, c: 10 }, e: { r: 2, c: 10 } },
        { s: { r: 1, c: 11 }, e: { r: 2, c: 11 } },

        { s: { r: 1, c: 12 }, e: { r: 1, c: 16 } },
        { s: { r: 2, c: 12 }, e: { r: 2, c: 12 } },
        { s: { r: 2, c: 13 }, e: { r: 2, c: 13 } },
        { s: { r: 2, c: 14 }, e: { r: 2, c: 14 } },
        { s: { r: 2, c: 15 }, e: { r: 2, c: 15 } },
        { s: { r: 2, c: 16 }, e: { r: 2, c: 16 } },

        { s: { r: 1, c: 17 }, e: { r: 1, c: 21 } },
        { s: { r: 2, c: 17 }, e: { r: 2, c: 17 } },
        { s: { r: 2, c: 18 }, e: { r: 2, c: 18 } },
        { s: { r: 2, c: 19 }, e: { r: 2, c: 19 } },
        { s: { r: 2, c: 20 }, e: { r: 2, c: 20 } },
        { s: { r: 2, c: 21 }, e: { r: 2, c: 21 } },

        { s: { r: 1, c: 22 }, e: { r: 2, c: 22 } },
        { s: { r: 1, c: 23 }, e: { r: 1, c: 25 } },
        { s: { r: 2, c: 23 }, e: { r: 2, c: 23 } },
        { s: { r: 2, c: 24 }, e: { r: 2, c: 24 } },
        { s: { r: 2, c: 25 }, e: { r: 2, c: 25 } },

        { s: { r: 1, c: 26 }, e: { r: 2, c: 26 } },

        { s: { r: 1, c: 27 }, e: { r: 1, c: 29 } },
        { s: { r: 2, c: 27 }, e: { r: 2, c: 27 } },
        { s: { r: 2, c: 28 }, e: { r: 2, c: 28 } },
        { s: { r: 2, c: 29 }, e: { r: 2, c: 29 } },

        { s: { r: 1, c: 30 }, e: { r: 2, c: 30 } },
        { s: { r: 1, c: 31 }, e: { r: 2, c: 31 } },
        { s: { r: 1, c: 32 }, e: { r: 2, c: 32 } },
        { s: { r: 1, c: 33 }, e: { r: 2, c: 33 } },
      );
      ws["!merges"] = merge;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Summary Report");
      XLSX.writeFile(wb, `Summary ${xlsxName}.xlsx`);
    }
  };
  const CustomerList = (nodename) => {
    var index = nodeList.indexOf(nodename);
    if (nodeList.includes("All")) {
      index = index;
    } else {
      index = index + 1;
    }
    return ["All", ...(customerAllList[index] || [])];
  };

  useEffect(() => {
    fetchAnotherData();
  }, []);

  const fetchAnotherData = async () => {
    try {
      // Use Promise.all for parallel fetching
      const [nodesDocs, itemsDocs, techDocs, docDocs, salesDocs] =
        await Promise.all([
          getDocs(collection(db, "nodes")),
          getDocs(collection(db, "items")),
          getDocs(collection(db, "sleeptechnicians")),
          getDocs(collection(db, "doctors")),
          getDocs(collection(db, "sales")),
          // getDocs(collectionGroup(db,"customers"))
        ]);

      let allCustomers = [];
      let allnodeIdDocs = [];
      let allItems = [];
      let allNodes;
      let allowedNodeDocs = nodesDocs.docs.map((nodeDoc) => ({
        id: nodeDoc.id,
        ...nodeDoc.data(),
      }));
      let currentAdminData = null;
      if (
        [
          "super_admin",
          "sale",
          "accountant",
          "sleep_technician",
          "sleep_physician",
        ].includes(currentUser.roles[0])
      ) {
        allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        for (const nodeDoc of nodesDocs.docs) {
          allnodeIdDocs = [...allnodeIdDocs, nodeDoc.id];
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeDoc.id, "customers"),
          );
          const customersData = customerDocs.docs.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
        allItems = itemsDocs.docs.map((doc) => ({
          ...doc.data(),
          itemcode: doc.id,
        }));
      }
      // else if (currentUser.roles[0] == "sleep_physician") {
      //   allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
      //   for (const nodeDoc of nodesDocs.docs) {
      //     allnodeIdDocs = [...allnodeIdDocs, nodeDoc.id];
      //     const customerDocs = await getDocs(
      //       collection(db, "nodes", nodeDoc.id, "customers")
      //     );
      //     const customersData = customerDocs.docs.map((customer) => {
      //       const customerData = customer.id;
      //       return customerData;
      //     });
      //     allCustomers.push(customersData);
      //   }
      //   allItems = itemsDocs.docs.map((doc) => ({
      //     ...doc.data(),
      //     itemcode: doc.id,
      //   }));
      // }
      else {
        // allNodes = nodesDocs.docs.map((doc) => doc.data().nodename);
        const currentAdmin = await getDoc(
          doc(db, "admins", currentUser.displayName),
        );
        currentAdminData = currentAdmin.exists() ? currentAdmin.data() : {};
        let nodeCode = currentAdminData.node || [];

        // Ensure `nodeCode` is always an array
        if (!Array.isArray(nodeCode)) {
          nodeCode = nodeCode ? [nodeCode] : []; // Convert to array or set to empty
        }

        // Find matching nodes
        allowedNodeDocs = allowedNodeDocs.filter((nodeData) =>
          nodeCode.includes(nodeData.nodecode),
        );

        allnodeIdDocs = allowedNodeDocs.map((nodeData) => nodeData.id);
        allNodes = allowedNodeDocs.map((nodeData) => nodeData.nodename);

        for (const nodeData of allowedNodeDocs) {
          const customerDocs = await getDocs(
            collection(db, "nodes", nodeData.id, "customers"),
          );
          const allowedCustomers = filterCustomersForStaffNode({
            customers: customerDocs.docs,
            currentUser,
            adminData: currentAdminData,
            nodeCode: nodeData.nodecode,
            getCustomerId: (customerDoc) => customerDoc.id,
          });
          const customersData = allowedCustomers.map((customer) => {
            const customerData = customer.id;
            return customerData;
          });
          allCustomers.push(customersData);
        }
        allItems = itemsDocs.docs
          .map((doc) => ({
            ...doc.data(),
            itemcode: doc.id,
          }))
          .filter((doc) => {
            return nodeCode.includes(doc.node);
          });
      }

      staffAccessContextRef.current = {
        adminData: currentAdminData,
        nodes: allowedNodeDocs,
      };
      setPostConsultNodes(allowedNodeDocs.map((node, index) => ({
        ...node, customers: allCustomers[index] || [],
      })));
      setLockStaffCustomerFilter(
        isStaffCustomerScopedUser(currentUser) &&
          hasExplicitStaffCustomerAccess(currentAdminData),
      );

      const allTechs = ["All", ...techDocs.docs.map((doc) => doc.data().name)];
      const allTechsRecord = [
        "All",
        ...techDocs.docs.map((doc) => doc.data().name),
      ];
      const allDocs = ["All", ...docDocs.docs.map((doc) => doc.data().name)];
      const allDocsTH = [
        "All",
        ...docDocs.docs.map((doc) => doc.data().fullnameEn),
      ];
      const allSales = Array.from(
        new Set(
          salesDocs.docs
            .map((saleDoc) => saleDoc.data().name || "")
            .filter(Boolean),
        ),
      ).sort((left, right) => left.localeCompare(right, "en"));
      setCustomerAllList(["All", ...allCustomers]);
      setCustomerList(["All", ...(allCustomers[0] || [])]);
      if (["staff"].includes(currentUser.roles[0])) {
        setNodeList([...allNodes]);
      } else {
        setNodeList(["All", ...allNodes]);
      }
      setNodeIdDocs(["All", ...allnodeIdDocs]);
      setSaleList(allSales);
      // setDoctorList(allDocs);
      // setDoctorTHList(allDocsTH);
      if (currentUser.roles[0] == "sleep_technician") {
        setTechRecordList([currentUser.displayName]);
        setTechnicianList([currentUser.displayName]);
      } else {
        setTechnicianList(allTechs);
        setTechRecordList(allTechsRecord);
      }

      if (currentUser.roles[0] == "sleep_physician") {
        setDoctorList([currentUser.displayName]);
        const docFullName = [
          ...docDocs.docs
            .filter((doc) => doc.data().name === currentUser.displayName) // Filter the documents
            .map((doc) => doc.data().fullnameEn), // Map to get only fullnameEn
        ];
        setDoctorTHList(docFullName);
      } else {
        setDoctorList(allDocs);
        setDoctorTHList(allDocsTH);
      }

      setItemList(allItems);
    } catch (error) {
      console.log("Error fetching data: ", error);
    }
  };

  const onChangeDateHandler = (dates) => {
    const [start, end] = dates;
    if (start) {
      start.setHours(0, 0, 0, 0); // Set time to 00:00:00
    }

    if (end) {
      end.setHours(23, 59, 59, 999); // Set time to 23:59:59.999
    }
    console.log(dates);
    setStartDate(new Date(start));
    setEndDate(new Date(end));
  };
  const GetFullNameDoctor = (doctor) => {
    const index = doctorList.findIndex((doc) => doc == doctor);
    if (index == -1) {
      return doctor;
    } else {
      return doctorTHList[index];
    }
  };
  return (
    <div className="row">
      <div className={getPostConsultSummaryNodes(currentUser, postConsultNodes).length ? "col-xl-6 mb-5" : "col-lg-12 mb-5"}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <b>Summary Report</b>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <b>{fetchingText}</b>
            <b>{fetchingPatientText}</b>
          </div>
        </div>

        {exportError && <div className="alert alert-warning mt-3" role="alert">{exportError}</div>}
        <ExportProgress progress={exportProgress} isExporting={isExporting} label="Sleep Study Summary" />
        <div className={getPostConsultSummaryNodes(currentUser, postConsultNodes).length ? "col-12 mt-4" : "col-xl-9 col-lg-12 mt-4"}>
          <fieldset disabled={isExporting}>
          <div className="form-group row">
            <label className="col-lg-3 col-form-label">
              {"Range Date"}
              <span className="text-danger"></span>
            </label>
            <div className="col-lg-9 row mx-0 px-0">
              <div className="col-sm-6 mb-2">
                <DatePicker
                  disabled={isExporting}
                  className="form-control"
                  wrapperClassName="w-100"
                  selected={startDate}
                  onChange={(date) => setStartDate(date.setHours(0, 0, 0, 0))}
                  selectsStart
                  startDate={startDate}
                  endDate={endDate}
                  minDate={null}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="dd/MM/yyyy"
                  // todayButton={true}
                />
              </div>
              <div className="col-sm-6 mb-2">
                <DatePicker
                  disabled={isExporting}
                  className="form-control"
                  wrapperClassName="w-100"
                  selected={endDate}
                  onChange={(date) =>
                    setEndDate(date.setHours(23, 59, 59, 999))
                  }
                  selectsEnd
                  startDate={startDate}
                  endDate={endDate}
                  minDate={startDate}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="dd/MM/yyyy"
                  todayBtn={true}
                />
              </div>
            </div>
          </div>
          <PatientDropDownForm
            title="Node"
            id="node"
            refvalue={nodeRef}
            // selected={currentBooking.extendedProps.node}
            options={nodeList}
            onChange={(e) => {
              setCustomerList(CustomerList(e.target.value));
            }}
            disabled={["sleep_technician", "sleep_physician"].includes(
              currentUser.roles[0],
            )}
          ></PatientDropDownForm>
          {lockStaffCustomerFilter ? (
            <LockedStaffCustomerField
              customerIds={customerList.filter(
                (customerId) => customerId !== "All",
              )}
            />
          ) : (
            <PatientDropDownForm
              title="Customer"
              id="customer"
              refvalue={customerRef}
              // selected={currentBooking.extendedProps.customer}
              options={customerList}
              disabled={["sleep_technician", "sleep_physician"].includes(
                currentUser.roles[0],
              )}
            ></PatientDropDownForm>
          )}
          <PatientDropDownForm
            title="Health Insurance"
            id="healthInsurance"
            refvalue={healthInsuranceRef}
            // selected={
            //     currentBooking.extendedProps.healthInsurance
            // }
            options={paymentPrivilagesData}
            disabled={["sleep_technician", "sleep_physician"].includes(
              currentUser.roles[0],
            )}
          ></PatientDropDownForm>
          <PatientDropDownForm
            title="Recording Tech"
            id="technician"
            refvalue={techRecordRef}
            disabled={currentUser.roles[0] == "staff"}
            // selected={currentBooking.extendedProps.techrecord}
            options={techrecordList}
          ></PatientDropDownForm>
          <PatientDropDownForm
            title="Scoring Tech"
            id="technician"
            refvalue={techRef}
            disabled={currentUser.roles[0] == "staff"}
            // selected={currentBooking.extendedProps.technician}
            options={technicianList}
          ></PatientDropDownForm>
          <PatientDropDownForm
            title="Doctor"
            id="doctor"
            refvalue={docRef}
            // disabled={currentUser.roles[0] == "staff"}
            // selected={currentBooking.extendedProps.doctor}
            options={doctorList}
            disabled={["sleep_technician", "staff", "sleep_physician"].includes(
              currentUser.roles[0],
            )}
            // onChange={handleStatusChange}
          ></PatientDropDownForm>
          <PatientDropDownForm
            title="Sale"
            id="sale"
            refvalue={saleRef}
            options={[
              BOOKING_SALE_FILTER_ALL,
              BOOKING_SALE_FILTER_UNASSIGNED,
              ...saleList,
            ]}
          ></PatientDropDownForm>
          {["super_admin", "admin", "staff", "sale", "accountant"].includes(
            currentUser.roles[0],
          ) && (
            <PatientCheckboxFormState
              title="Filter case"
              options={[
                "Only finished cases",
                FINISHED_REPORT_CHECK_PASSED_FILTER,
                FINISHED_REPORT_CHECK_NOT_PASSED_FILTER,
                "Only Ship [CPAP Purchase]",
                "All cases",
                "All cases excluding Failure",
                "Cancel and Failure cases only",
                // "All cases with CPAP sold",
              ]}
              name="filter"
              selectedFilter={selectedFilter} // Pass selectedFilter state
              setSelectedFilter={selectCaseFilter} // Pass setter function
            />
          )}

          <div className="form-group row">
            <label className="col-xl-3 col-form-label">Status</label>
            <div className="col-xl-5">
              <div className="form-check mb-2">
                <input
                  id="export-sleep-study-status-filter"
                  className="form-check-input"
                  type="checkbox"
                  checked={filterByStatus}
                  onChange={(event) => {
                    const enabled = event.target.checked;
                    setFilterByStatus(enabled);
                    setSelectedStatus("");
                    if (enabled) setSelectedFilter("");
                  }}
                />
                <label
                  className="form-check-label"
                  htmlFor="export-sleep-study-status-filter"
                >
                  Filter by exact status
                </label>
              </div>

              {filterByStatus && (
                <select
                  className="form-control"
                  value={selectedStatus}
                  onChange={(event) => setSelectedStatus(event.target.value)}
                >
                  <option value="">Select status</option>
                  {statusList.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              )}
              {filterByStatus && (
                <small className="form-text text-muted">
                  Selecting a Filter case option will clear this status filter.
                </small>
              )}
            </div>
          </div>

          <Button onClick={onExport} disabled={isExporting}>
            {isExporting ? `Exporting ${exportProgress ? exportProgress.percent : 0}%...` : "Export"}
          </Button>
          </fieldset>
        </div>
      </div>
      <PostConsultSummary currentUser={currentUser} allowedNodes={postConsultNodes} />
    </div>
  );
};

export default SleepStudySummary;
